import { LandingPage } from "one-ui-library";
import React, { useState } from "react";

import { ODSLoadingSpinner, ODSToast } from "@telekom-ods/react-ui-kit";
import { RouteConfigComponentProps } from "react-router-config";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useSiteData } from "src/SiteDataProvider";
// import ContactForm from "src/components/ContactUs";
import FooterWrapper from "src/components/Footer";
import { appData } from "src/constants";
import { getScriptsFromPB } from "src/utils/getScriptTags";
import {
  getAbsoluteUrl,
  parseLandingPageStaticContent,
} from "src/utils/parseData";
import {
  LandingPageWrapper,
  StyledLoaderWrapper,
  StyledMainWrapper,
  StyledToastWrapper,
} from "./styles";

import HeaderWrapper from "src/components/Header3";
import ErrorBlock from "src/components/ErrorBlock";
import Career from "src/components/Career";

interface IProps {
  setTitle: (data: string) => void;
  setPromptingPageData: (data: any) => void;
}

type ODSTypeType = "success" | "information";

console.warn("REACT_APP_API_URL", process.env.REACT_APP_API_URL);
console.warn("REACT_APP_INSTANCE_ID", process.env.REACT_APP_INSTANCE_ID);
const defaultToastValue = {
  title: "",
  message: "",
  show: false,
  type: "success",
};
type HomeProps = IProps & RouteConfigComponentProps<any>;
const SitePage: React.FC<HomeProps> = (__props: IProps) => {
  const location = useLocation();
  const [toastData, setToastData] = useState(defaultToastValue);

  const { data, error, isLoading } = useSiteData();

  const getScriptTags = () => {
    return getScriptsFromPB(data?.pageContent?.data || []);
  };

  const getRobotTags = () => {
    const robot = data?.slugMetadata?.robot;
    if (robot) {
      return Object.keys(robot).map((key: string) => {
        if (robot[key]) {
          return <meta name="robots" content={key} key={key} />;
        }

        return;
      });
    }

    return;
  };

  const isBrowser = (() => {
    let browser = false;
    try {
      if (!!window && !!document && !!document.location) {
        browser = true;
      }
    } catch (e) {}

    return browser;
  })();

  return (
    <>
      <Helmet>
        <title>{data?.slugMetadata?.seoTitle || "DTDL"}</title>
        <meta name="description" content={data?.slugMetadata?.seoDescription} />
        <meta property="og:title" content={data?.slugMetadata?.ogTitle} />
        <meta
          property="og:description"
          content={data?.slugMetadata?.ogDescription}
        />
        <meta
          property="og:image"
          content={getAbsoluteUrl(data?.slugMetadata?.ogImageUrl, appData)}
        />
        {getRobotTags()}
        {data?.slugMetadata?.setCanonical && (
          <link
            rel="canonical"
            href={`${isBrowser ? window.location.href : ""}`}
          />
        )}
        {getScriptTags()}
      </Helmet>
      <StyledToastWrapper>
        <ODSToast
          onClose={function closeToast() {
            setToastData(defaultToastValue);
          }}
          timeout={3000}
          title={toastData.message}
          type={toastData.type as ODSTypeType}
          opened={toastData.show}
        />
      </StyledToastWrapper>

      {isLoading && (
        <StyledLoaderWrapper>
          <ODSLoadingSpinner
            labelAlignment="horizontal"
            labelText="Loading ..."
            size="large"
          />{" "}
        </StyledLoaderWrapper>
      )}

      {!isLoading && (
        <StyledMainWrapper>
          <HeaderWrapper />
          {error && <ErrorBlock />}
          {data && (
            <>
              {" "}
              <LandingPageWrapper>
                {!error && location?.pathname === "/joinus" && (
                  // <ExploreCareers/>
                  <Career />
                )}
                <LandingPage
                  showAppShell={false}
                  dynamicReactNode={""}
                  ssoLoginUri={""}
                  ssoWhiteListDomains={[]}
                  sectionItems={parseLandingPageStaticContent(
                    data?.pageContent?.data,
                    appData
                  )}
                />
              </LandingPageWrapper>
            </>
          )}

          {!isLoading && <FooterWrapper />}
        </StyledMainWrapper>
      )}
    </>
  );
};

export default SitePage;
